<template>
    <div id="mapContent">
        <!-- <h1>市场产地来源</h1> -->
        <div id="map"></div>
        <div id="selects">
            <select name="selectValue" id="selectValue" v-model="selectValue" @change="selectChange">
                <option v-for="(item,index) in selectArr" :key="index" :value="item.goods_id">{{ item.goods_name }}
                </option>
            </select>
        </div>
    </div>
</template>
<script>
import * as echarts from "echarts";
import { mapState } from "vuex";
import chinaMapRegister from "@/utils/china";
import chinaGeoCoordMap from "@/utils/chinaGeoCoordMap"; //中国地图经纬度

export default {
    data () {
        return {
            //地图的数据
            mapData: [],
            itemData: [],
            selectValue: 0,
            selectArr: [],
            selectIndex: 0
        };
    },
    watch: {
        dateType (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getPlaceTop10GoodsNameList();
            }
        },
    },
    computed: {
        ...mapState(["dateType"]),
    },
    mounted () {
        this.getPlaceTop10GoodsNameList()

        // this.selectValue = this.selectArr[this.selectIndex].value
        setInterval(() => {
            this.selectIndex++
            if (this.selectIndex == this.selectArr.length) {
                this.selectIndex = 0
            }
            // console.log(this.selectIndex);
            this.selectValue = this.selectArr[this.selectIndex].goods_id
            this.getData()
        }, 5000)
    },
    methods: {
        // 获取前10商品品种名称
        async getPlaceTop10GoodsNameList () {
            await this.$http
                .get("/screen/getPlaceTop10GoodsNameList?type=" + this.dateType, {})
                .then((response) => {
                    if (response.data.resultCode === 200) {
                        this.selectArr = response.data.data;
                        this.selectValue = response.data.data[0].goods_id
                        this.getData();
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        // 下拉框数据改变
        selectChange () {
            // console.log(this.selectValue);
            this.getData()
        },
        //获取后台的数据
        async getData () {
            await this.$http
                .get("/screen/getPlaceTop10ListForGoodsName?type=" + this.dateType + '&goodsId=' + this.selectValue, {})
                .then((response) => {
                    if (response.data.resultCode === 200) {
                        // console.log(response, "--------ditu");
                        this.mapData = response.data.data;
                        this.mapData.forEach(item => {
                            item.name = item.place_name
                            item.value = 0
                        })
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            this.showMap();
        },
        showMap () {
            let chartDom = document.getElementById("map");
            let myChart = echarts.init(chartDom);
            let option = [];
            chinaMapRegister(echarts);
            //渲染数据
            let chinaDatas = this.mapData;
            // console.log("chinaDatas", chinaDatas);

            var convertData = function (data) {
                var res = [];
                for (var i = 0; i < data.length; i++) {
                    var dataItem = data[i];
                    // console.log(dataItem);
                    var fromCoord = chinaGeoCoordMap[dataItem.name];
                    //山东新泰
                    var toCoord = [117.45, 35.54];
                    if (fromCoord && toCoord) {
                        res.push([
                            {
                                coord: fromCoord,
                                value: dataItem.value,
                            },
                            {
                                coord: toCoord,
                            },
                        ]);
                    }
                }
                return res;
            };

            let series = [];
            [["山东新泰", chinaDatas]].forEach(function (item, i) {
                // console.log(item[1]);
                series.push(
                    {
                        type: "lines",
                        zlevel: 2,
                        effect: {
                            show: true,
                            period: 4, //箭头指向速度，值越小速度越快
                            trailLength: 0.02, //特效尾迹长度[0,1]值越大，尾迹越长重
                            symbol: "arrow", //箭头图标
                            symbolSize: 5, //图标大小
                        },
                        lineStyle: {
                            normal: {
                                width: 1, //尾迹线条宽度
                                opacity: 1, //尾迹线条透明度
                                curveness: 0.3, //尾迹线条曲直度
                            },
                        },
                        itemStyle: {
                            normal: {
                                show: true,
                                color: "#F00",
                                shadowBlur: 5,
                                shadowColor: '#f00'
                            },
                        },
                        data: convertData(item[1]),
                    },
                    {
                        type: "effectScatter",
                        coordinateSystem: "geo",
                        zlevel: 2,
                        rippleEffect: {
                            //涟漪特效
                            period: 4, //动画时间，值越小速度越快
                            brushType: "stroke", //波纹绘制方式 stroke, fill
                            scale: 4, //波纹圆环最大限制，值越大波纹越大
                        },
                        symbol: "circle",
                        itemStyle: {
                            normal: {
                                show: true,
                                color: "#f8e71c",
                                // shadowBlur:5,
                                // shadowColor:'#f00'
                            },
                        },
                        data: item[1].map(function (dataItem) {
                            return {
                                name: dataItem.name,
                                value: chinaGeoCoordMap[dataItem.name],
                            };
                        }),
                    },
                    //被攻击点
                    {
                        type: "scatter",
                        coordinateSystem: "geo",
                        zlevel: 999,
                        rippleEffect: {
                            period: 18,
                            color: "#f00",
                            brushType: "stroke",
                            scale: 4,
                        },
                        label: {
                            normal: {
                                show: true,
                                position: "bottom", // 文字位置
                                color: "#fff", // 颜色
                                formatter: "{b}",
                                fontSize: 18, // 被攻击地点文字大小
                                fontWeight: "bold",
                                offset: [45, 0, 0, 0], // 文字偏移量
                            }
                        },
                        symbol: "pin",
                        symbolSize: 40,
                        itemStyle: {
                            normal: {
                                color: '#f00'
                            }
                        },
                        data: [
                            {
                                name: item[0],
                                value: chinaGeoCoordMap[item[0]],
                            },
                        ],
                    }
                );
            });

            option = {
                title: {
                    text: "市场产地来源",
                    left: "50%",
                    textAlign: "center",
                    textStyle: {
                        color: "#04DEFF",
                        fontSize: 20,
                        fontWeight: 800,
                    },
                    padding: [15, 0, 0, 0],
                },
                tooltip: {
                    showContent: function (params) {
                        // console.log(params);
                        return true;
                    },
                    trigger: "item",
                    backgroundColor: "rgba(166, 200, 76)",
                    borderColor: "#00FFFF",
                    showDelay: 0,
                    hideDelay: 0,
                    enterable: true,
                    transitionDuration: 0,
                    extraCssText: "z-index:100",
                    formatter: function (params) {
                        let name = params.name;
                        let res = `<span style='color:#fff;'> ${name}</span>`;
                        return !!name ? res : false;
                    },
                },
                // backgroundColor: "#013954",
                visualMap: {
                    //图例值控制
                    min: 0,
                    max: 1,
                    calculable: false,
                    show: false,
                    color: ["#00eaff", "#00eaff", "#00eaff", "#00eaff", "#00eaff"],
                    textStyle: {
                        color: "#fff",
                    },
                },
                geo: {
                    map: "china",
                    zoom: 1.2,
                    label: {
                        emphasis: {
                            show: false,
                        },
                    },
                    //滚轮缩放的极限控制
                    roam: true,
                    scaleLimit: {

                        min: 1, //最小1倍

                        max: 8 //最大3倍

                    },
                    // roam: false, //是否允许缩放
                    itemStyle: {
                        normal: {
                            color: "#011746", //地图背景色
                            borderColor: "#516a89", //省市边界线00fcff 516a89
                            borderWidth: 1,
                        },
                        emphasis: {
                            color: "rgba(60, 83, 61, .5)", //点击省份悬浮背景
                        },
                    },
                    // center: [117.45, 35.54]
                },
                series: series,
            };

            myChart.setOption(option);
        },
    },
};
</script>

<style scoped>
#map {
    /*width: calc(var(--width) * 0.3);*/
    width: 100%;
    height: calc(var(--height) * 0.925 * 0.63);
    background-image: url("@/assets/images/bg-map.png");
    background-repeat: round;
}
#mapContent {
    position: relative;
}
#selects {
    position: absolute;
    top: 20px;
    left: 20px;
    background: #0e2465;
    width: 200px;
    height: 40px;
}
#selectValue {
    background: #0e2465 !important;
    color: #fff;
    width: 100%;
    height: 100%;
    border: 1px solid #fff;
    border-radius: 5px;
}
</style>
